// extracted by mini-css-extract-plugin
module.exports = {"container":"HomeView_container__EOxdw","body":"HomeView_body__2JzvO"};